import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"
import Keyb from "keyb"
import Delta from "@frog/source/models/Delta.js"
import Stage from "@frog/source/models/Stage.js"
import * as Objdict from "objdict"

import * as Motions from "@frog/source/juice/utility/Motions.js"
import Timings from "@frog/source/juice/utility/Timings.js"
import {colortween, tween} from "@frog/source/juice/utility/Tweens.js"

import skills from "@frog/source/data/skills/skills.js"
import animations from "@frog/source/juice/animations.js"
import app from "@frog/source/models/App.js"

// import FMODManager from "@frog/source/utility/FMOD/FMODManager.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

export default new class Director {
    constructor() {
        this.steps = []
    }
    addEvents(stage, events) {
        this.add(Stage.processEventSteps(stage, events))
    }
    add(steps) {
        App.game.encounter.sequence = {steps}
    }
    // skip() {
    //     while(this.steps.length > 0
    //     && this.steps[0].canBeSkipped) {
    //         this.steps[0].skip()
    //         this.steps.shift()
    //
    //         // if(this.steps[0].hasFinished == false) {
    //         //     if(this.steps[0].skip instanceof Function) {
    //         //         this.steps[0].skip()
    //         //     }
    //         // }
    //     }
    // }
    // dump() {
    //     while(this.steps.length > 0) {
    //         this.bump()
    //     }
    // }
    get isPerforming() {
        return App.game.encounter.sequence?.steps != undefined
            && App.game.encounter.sequence.steps.length > 0
    }
    // Director.updateSequence({sequence, delta})
    // const sequence = {
    //     "isLooping": true,
    //     "steps": [step, step, step]
    // }
    // TODO: Combine with App.js Sequence
    updateSequence({sequence, delta}) {
        if(sequence == undefined) return
        if(sequence.isInstantiated != true) {
            sequence.isInstantiated = true
            sequence.steps = sequence.steps.map((step) => {
                return Step.instantiate(Step.copy(step))
            })
        }

        const step = sequence.steps[0]
        if(step == undefined) return

        const SPEED_UP = 1.5
        step.time += delta.ms * SPEED_UP

        if(step.func != undefined) {
            let extrasteps = step.func(step.alphastage)
            Sequence.shift(sequence)
            if(extrasteps != undefined) {
                // BE WARNED! These extra steps don't affect
                // the end stage, because that stage has been
                // precomputed long before it was sent to the
                // director.
                if(extrasteps instanceof Array == false) {
                    extrasteps = [extrasteps]
                }
                sequence.steps = extrasteps.concat(sequence.steps)
            }
            // if(step.hasFuncd == undefined) {
            //     step.hasFuncd = true
            //     step.functime = step.func()
            // }
            // if(step.time >= step.functime) {
            //     steps.shift()
            // }
        } else if(step.animation != undefined) {
            Step.executeAnimation({
                "stage": step.stage,
                "animation": step.animation,
                "currentDuration": step.time
            })

            if(step.time >= step.animation.maxmark) {
                Sequence.shift(sequence)
            }
        } else if(step.duration != undefined) {
            step.stage = step.omegastage // THIS SHOULD BE HAPPENING IN AN ANIMATION!!
            if(step.time >= step.duration) {
                Sequence.shift(sequence)
            }
        } else {
            Sequence.shift(sequence)
        }
    }
}

// Combine with App.js Sequence
class Sequence {
    static shift(sequence) {
        const step = sequence.steps.shift()
        if(sequence.isLooping == true) {
            sequence.steps.push(Step.instantiate(step))
        }
    }
}

// TODO: Combine with Step.js
class Step {
    static copy(step) {
        const copystep = {}
        for(let key in step) {
            copystep[key] = step[key]
        }
        return copystep
        // return {
        //     "type": step.type, // "move" | "invoke skill" | "death",
        //     "alphastage": step.alphastage,
        //     "omegastage": step.omegastage,
        //     "deltastages": step.deltastages,
        //     // TOOD: ALL OF THIS IS COPY BY REFERENCE...?
        // }
    }
    static instantiate(step) {
        step.hasStarted = false
        step.hasFinished = false
        step.isInstantiated = true
        step.time = 0 // in milliseconds

        if(step.func != undefined) return step

        if(step.alphastage != undefined) {
            step.stage = Stage.copy(step.alphastage)
        }
        if(animations[step.type] != undefined) {
            step.animation = animations[step.type](step)
        }
        if(step.animation != undefined) {
            step.animation = Step.processAnimation(step.animation)
        }

        return step
    }
    static updateStep(step, delta) {
        step.hasStarted = true

        step.time += delta.ms
        step.accumulatedTime += delta.ms

        while(step.sequence.length > 0) {
            if(step.sequence[0] instanceof Function) {
                step.sequence[0].call()
                step.sequence.shift()
                continue
            }
            if(step.sequence[0].execute instanceof Function) {
                step.sequence[0].execute(step.time)
            }
            if(step.sequence[0].duration != undefined) {
                if(step.accumulatedTime > step.sequence[0].duration) {
                    step.accumulatedTime -= step.sequence[0].duration
                    step.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // else {
            // step.sequence.shift()
            // continue
            // }
            if(step.sequence[0].condition != undefined) {
                if(!!step.sequence[0].condition()) {
                    step.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // if(step.sequence[0].isUnskippable == true) {
            //     step.sequence.shift()
            //     return
            // }
        }

        if(step.sequence.length == 0) {
            Step.finish(step)
        }
    }
    static finish(step) {
        step.hasFinished = true

        if(step.onFinish instanceof Function) {
            step.onFinish()
        }
    }
    // accepts: an array of either keyframes or subarrays of keyframes.
    // outputs: an array of keyframes
    static flattenKeyframes(keyframes) {
        let output = []
        keyframes.forEach((keyframe) => {
            if(keyframe instanceof Array) {
                output = output.concat(Step.flattenKeyframes(keyframe))
            } else {
                output.push(keyframe)
            }
        })
        return output
    }
    static processAnimation(animation) {
        animation.maxmark = 0

        // Flatten arrays of arrays of arrays of keyframes to just a single array of keyframes.
        animation.keyframes = Step.flattenKeyframes(animation.keyframes)

        // Remove any undefined keyframes, like conditionally skipped keyframes.
        animation.keyframes = animation.keyframes.filter((keyframe) => !!keyframe)

        // Separate each keyframe into their own timeline,
        // each for a different property.
        animation.timelines = {}
        animation.keyframes.forEach((keyframe) => {
            // KEYFRAME SCHEMA v2 - a frame with timing and motion and a mark
            // to know when it happens, and then an object to be Delta.editStage'd,
            // currently only supporting keyframe.unit
            if(keyframe.unit != undefined) {
                Object.keys(keyframe.unit).forEach((property) => {
                    if(property == "key") return
                    const timelineKey = keyframe.unit.key + "." + property

                    animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                    animation.timelines[timelineKey].push({
                        "mark": keyframe.mark,
                        "timing": keyframe.timing,
                        "motion": keyframe.motion,
                        "unit": {
                            "key": keyframe.unit.key,
                            [property]: keyframe.unit[property]
                        },
                    })
                })
            }
            // KEYFRAME SCHEMA v1 - a big object that had a type (to decide between
            // particles and units) and key, a bunch of meta tweening data, and then
            // all other keys were to be tween'd individually. and of course a mark for
            // when to make this frame happen!
            if(keyframe.unit == undefined) {
                Object.keys(keyframe).forEach((key) => {
                    if(key == "key"
                    || key == "mark"
                    || key == "type"
                    || key == "timing"
                    || key == "motion") {
                        return
                    }

                    // keyframe has many properties.
                    // key == property key

                    const timelineKey = (keyframe.key !== undefined ? keyframe.key + "." : "") + key

                    animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                    animation.timelines[timelineKey].push({
                        "key": keyframe.key,
                        "mark": keyframe.mark,
                        "type": keyframe.type,
                        "timing": keyframe.timing,
                        "motion": keyframe.motion,
                        [key]: keyframe[key]
                    })
                })
            }

            if(animation.maxmark < keyframe.mark) {
                animation.maxmark = keyframe.mark
            }
        })
        // console.log(JSON.stringify(animation.timelines["audio"]))
        // console.log(animation.timelines) // DEBUG

        // Sort each timeline.
        Objdict.forEach(animation.timelines, (timeline) => {
            timeline.sort((a, b) => {
                if(a.mark < b.mark) return -1
                if(a.mark > b.mark) return +1
                return 0
            })
        })

        return animation
    }
    static executeAnimation({animation, stage, currentDuration}) {
        const tweenFrame = {"mark": currentDuration}

        if(animation.timelines != undefined) {
            Objdict.forEach(animation.timelines, (timeline) => {
                // TODO: iterate through as many keyframes in this timeline as
                // need to, in case there are many keyframes for this single
                // property all happening at the same time.
                if(timeline[1] != undefined
                && timeline[1].mark < tweenFrame.mark) {
                    // Step.performFrame(stage, timeline[0])
                    // Step.performFrame(stage, timeline[1])
                    timeline.shift()
                    return
                }
                if(timeline[0] == undefined) {
                    return
                }
                if(timeline[0].mark > tweenFrame.mark) {
                    return
                }

                // Run this frame only once

                if(timeline[0].type == "log") {
                    Step.performFrame(stage, timeline[0])
                    timeline.shift()
                    return
                }

                if(timeline[0].do instanceof Function) {
                    timeline[0].do()
                    timeline.shift()
                    return
                }
                // this is not to be confused with step.func, this is step.deltastages[x].func.
                if(timeline[0].func instanceof Function) {
                    timeline[0].func()
                    timeline.shift()
                    return
                }
                if(timeline[0].function instanceof Function) {
                    timeline[0].function()
                    timeline.shift()
                    return
                }

                if(timeline[0].audio != undefined) {
                    Step.performFrame(stage, timeline[0])
                    timeline.shift()
                    return
                }

                // Run this frame for every frame in-between

                const previousFrame = timeline[0]
                const nextFrame = timeline[1]
                Step.performFrame(stage, previousFrame, tweenFrame, nextFrame)
            })
        }
    }
    static performFrame(stage, previousFrame, tweenFrame, nextFrame) {
        tweenFrame = tweenFrame || previousFrame
        nextFrame = nextFrame || previousFrame

        const progress = Math.min(1, (tweenFrame.mark - previousFrame.mark) / (nextFrame.mark - previousFrame.mark))
        const timing = nextFrame.timing || Timings.linear
        const motion = nextFrame.motion || Motions.line

        // KEYFRAME SCHEMA v2
        if(previousFrame.unit != undefined) {
            if(previousFrame.unit.key == undefined) {
                return
            }

            const unit = stage.units[previousFrame.unit.key]
            if(unit == undefined) return

            const previousUnit = previousFrame.unit
            const nextUnit = nextFrame.unit

            const UnitProperties = {
                "position": "motiontween",
                "opacity": "tween",
                "image": "static",
                "health": "static",
                "armor": "static",
                // "static": the moment this becomes the previousFrame, it happens
                // "tween": so long as the previousFrame also has this property,
                // this will start tweening it to moment this becomes the nextFrame.
                // we do not currently check nextFrame at all, so if the previous
                // frame is missing it, we don't default it. that would be wild
                // to try coding, right? because we'd be assuming that this is
                // where the animation starts from, and would need to backfill
                // a frame for that before the next frame. yeah, that'd suck.
            }

            Object.keys(previousUnit).forEach((property) => {
                if(property == "key") return

                // for all of these tweens, do i need to be checking if
                // next frame exists? currently, it defaults to this previous
                // frame, which owuld mean i'm just tweening from me to me.
                // if next frame exists but the propety isn't there? should
                // i default it? woudl that ever happen with this system of
                // corraled units?

                if(previousUnit[property] == undefined) {
                    return
                }

                if(nextUnit[property] != undefined) {
                    if(UnitProperties[property] == "tween") {
                        unit[property] = tween(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                    if(UnitProperties[property] == "motiontween") {
                        unit[property] = motion(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                    if(UnitProperties[property] == "colortween") {
                        unit[property] = colortween(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                }

                // if(UnitProperties[property] == "static"
                // || UnitProperties[property] == undefined) {
                unit[property] = previousUnit[property]
                if(previousUnit[property] === null) {
                    unit[property] = undefined
                }

                // i am currently supporting null for disabling a property.
                // hey what does that mean if i try tweening between a valid
                // value and null???
            })
        }

        if(previousFrame.audio != undefined) {
            if(previousFrame.audio.triggerKey != undefined) {
                Audiomix.trigger(previousFrame.audio.triggerKey)
            }
        }

        // KEYFRAME SCHEMA v1
        // WHAT HAPPENS IF THE POSITION IS NOT DEFINED AND WE
        // STILL TRY TO TWEEN IT? BE SURE TO DEFAULT OR ABORT.
        if(previousFrame.type == "particle") {
            stage.particles = stage.particles || {}
            stage.particles[previousFrame.key] = stage.particles[previousFrame.key] || {}
            if(previousFrame.image != undefined) {
                stage.particles[previousFrame.key].image = previousFrame.image
            }if(previousFrame.space != undefined) {
                stage.particles[previousFrame.key].space = previousFrame.space
            }
            if(previousFrame.text != undefined) {
                stage.particles[previousFrame.key].text = previousFrame.text
            }
            if(previousFrame.stack != undefined) {
                stage.particles[previousFrame.key].stack = previousFrame.stack
            }
            if(previousFrame.color != undefined) {
                stage.particles[previousFrame.key].color = previousFrame.color
            }
            if(previousFrame.height != undefined) {
                stage.particles[previousFrame.key].height = previousFrame.height
            }
            if(previousFrame.width != undefined) {
                stage.particles[previousFrame.key].width = previousFrame.width
            }
            if(previousFrame.anchor != undefined) {
                stage.particles[previousFrame.key].anchor = previousFrame.anchor
            }
            if(previousFrame.scale != undefined) {
                if(nextFrame.scale != undefined) {
                    if(previousFrame.scale instanceof Object) {
                        stage.particles[previousFrame.key].scale = motion(previousFrame.scale, nextFrame.scale, timing(progress))
                    } else {
                        stage.particles[previousFrame.key].scale = tween(previousFrame.scale, nextFrame.scale, timing(progress))
                    }
                } else {
                    if(previousFrame.scale instanceof Object) {
                        stage.particles[previousFrame.key].scale = stage.particles[previousFrame.key].scale || {}
                        stage.particles[previousFrame.key].scale.x = previousFrame.scale.x
                        stage.particles[previousFrame.key].scale.y = previousFrame.scale.y
                    } else {
                        stage.particles[previousFrame.key].scale = previousFrame.scale
                    }
                }
            }
            if(previousFrame.tint != undefined) {
                stage.particles[previousFrame.key].tint = previousFrame.tint // TODO: tween
            }
            if(previousFrame.opacity != undefined && nextFrame.opacity != undefined) {
                stage.particles[previousFrame.key].opacity = tween(previousFrame.opacity, nextFrame.opacity, timing(progress))
            }
            if(previousFrame.position != undefined && nextFrame.position != undefined) {
                stage.particles[previousFrame.key].position = motion(previousFrame.position, nextFrame.position, timing(progress))
            }
            if(previousFrame.followTerrain != undefined) {
                const currentPosition = stage.particles[previousFrame.key].position
                if(currentPosition != undefined) {
                    const flooredPosition = { "x": Math.floor(currentPosition.x), "y": Math.floor(currentPosition.y) }
                    const terrain = World.getTerrain(stage.world, flooredPosition)
                    let zOverride = null
                    if(terrain != undefined) {
                        zOverride = terrain.size.z
                        if(previousFrame.followTerrain.zOffset != undefined) {
                            zOverride += previousFrame.followTerrain.zOffset
                        }
                    }

                    if(zOverride != null) {
                        stage.particles[previousFrame.key].zOverride = zOverride
                    } else {
                        stage.particles[previousFrame.key].zOverride = undefined
                    }
                }
            }
            if(previousFrame.anchor != undefined) { // && nextFrame.anchor != undefined) {
                stage.particles[previousFrame.key].anchor = previousFrame.anchor // motion(previousFrame.anchor, nextFrame.anchor, timing(progress))
            }
            if(previousFrame.rotation != undefined && nextFrame.rotation != undefined) {
                stage.particles[previousFrame.key].rotation = tween(previousFrame.rotation, nextFrame.rotation, timing(progress))
            }
            // TODO: this is done... when it's a previous frame, yeah? like health and the like? is that wieird?
            if(previousFrame.delete == true) {
                delete stage.particles[previousFrame.key]
            }
            return
        }

        if(previousFrame.type == "log") {
            stage.logs = stage.logs || []
            stage.logs.push({
                "text": previousFrame.text,
            })
            return
        }
    }
}



// Not yet in v2 schema.
// Not that it needs to be.
// But just listing it here
// for posterity.
// - isAnimating
// - rotation
// - grayscale
